import { render, staticRenderFns } from "./CustomQuestionAnswerTextarea.vue?vue&type=template&id=13be6aea"
import script from "./CustomQuestionAnswerTextarea.vue?vue&type=script&lang=js"
export * from "./CustomQuestionAnswerTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports